/**
 * Environment variables and endpoint resolution.
 *
 * The Kardume core runs with `context-path: /api`, so the axios instance
 * targets `${API_BASE_URL}/api`.
 */
export const API_BASE_URL: string =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : '');

export const API_CONTEXT_PATH = '/api';

export const API_URL = `${API_BASE_URL}${API_CONTEXT_PATH}`;
